import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7160f95d&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=7160f95d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160f95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7160f95d')) {
      api.createRecord('7160f95d', component.options)
    } else {
      api.reload('7160f95d', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=7160f95d&scoped=true&", function () {
      api.rerender('7160f95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4p7CN6WJbHERt/JS/comp/PopupDialog.vue"
export default component.exports